/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface GetActiveLootBoxConfigsResponse
 */
export interface GetActiveLootBoxConfigsResponse {
    /**
     * 
     * @type {Array<LootBoxConfigResponse>}
     * @memberof GetActiveLootBoxConfigsResponse
     */
    lootBoxConfigs: Array<LootBoxConfigResponse>;
}

/**
 * Check if a given object implements the GetActiveLootBoxConfigsResponse interface.
 */
export function instanceOfGetActiveLootBoxConfigsResponse(value: object): value is GetActiveLootBoxConfigsResponse {
    if (!('lootBoxConfigs' in value) || value['lootBoxConfigs'] === undefined) return false;
    return true;
}

export function GetActiveLootBoxConfigsResponseFromJSON(json: any): GetActiveLootBoxConfigsResponse {
    return GetActiveLootBoxConfigsResponseFromJSONTyped(json, false);
}

export function GetActiveLootBoxConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetActiveLootBoxConfigsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfigs': ((json['lootBoxConfigs'] as Array<any>).map(LootBoxConfigResponseFromJSON)),
    };
}

export function GetActiveLootBoxConfigsResponseToJSON(json: any): GetActiveLootBoxConfigsResponse {
    return GetActiveLootBoxConfigsResponseToJSONTyped(json, false);
}

export function GetActiveLootBoxConfigsResponseToJSONTyped(value?: GetActiveLootBoxConfigsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfigs': ((value['lootBoxConfigs'] as Array<any>).map(LootBoxConfigResponseToJSON)),
    };
}

